import React from "react";
import {
  Grid3x3,
  Zap,
  Shield,
  Fence,
  Hammer,
  Sparkles,
  CarFront,
  DoorOpen,
  DoorClosed,
  Building2,
  Trophy,
  Wrench,
} from "lucide-react";
import ServiceCard from "./ServiceCard";

// Security-focused product list (Alambrados Aloma)
const SERVICES = [
  { icon: Grid3x3, title: "Malla Ciclónica", desc: "Cercado perimetral en malla ciclónica para industrias, plantas y desarrollos." },
  { icon: Zap, title: "Cercas Electrificadas", desc: "Sistemas de cerco electrificado de alta y baja tensión con tableros y monitoreo." },
  { icon: Shield, title: "Reja de Acero", desc: "Rejas para fachadas, perímetros y protecciones especiales en acero estructural." },
  {
    icon: Trophy,
    title: "Mallas y Redes Deportivas",
    desc: "Mallas y redes para campos de golf, canchas de tenis, pádel, fútbol y áreas deportivas.",
    image: "https://customer-assets.emergentagent.com/job_admiring-cerf-5/artifacts/v0qlkgyg_WhatsApp%20Image%202026-05-05%20at%2016.29.34%20%281%29.jpeg",
  },
  { icon: Hammer, title: "Herrería", desc: "Trabajos de herrería general para obra residencial, industrial y comercial." },
  { icon: Fence, title: "Alambrados Perimetrales", desc: "Sistemas de alambrado para grandes superficies, plantas y predios industriales." },
  { icon: Sparkles, title: "Concertina y Púas", desc: "Accesorios disuasivos: concertina, alambre de púas y refuerzos perimetrales." },
  { icon: CarFront, title: "Portones Automáticos y Manuales", desc: "Portones de alto tráfico con sistemas eléctricos y motorización integrada." },
  { icon: DoorOpen, title: "Puertas de Emergencia", desc: "Puertas certificadas para evacuación y normativas de seguridad." },
  { icon: DoorClosed, title: "Canceles de Acero", desc: "Canceles funcionales y arquitectónicos en acero a la medida." },
  { icon: Building2, title: "Herrería Arquitectónica", desc: "Diseños finos para hoteles, residencias y proyectos turísticos." },
  { icon: Wrench, title: "Fabricaciones Especiales", desc: "Soluciones a medida según requerimiento del proyecto." },
];

const SERVICE_IMG_1 =
  "https://customer-assets.emergentagent.com/job_admiring-cerf-5/artifacts/lf3bgklr_REJA%201.jpg";

const scrollToContactWithPrefill = (serviceTitle) => {
  const el = document.getElementById("contacto");
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth" });
  setTimeout(() => {
    window.dispatchEvent(
      new CustomEvent("prefill-service", { detail: serviceTitle })
    );
  }, 400);
};

const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[#F4F1E8] py-24 md:py-32 border-t-2 border-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono-tag text-xs text-[#0A0A0A] mb-4">// PRODUCTOS</p>
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-end">
          <div className="lg:col-span-7">
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-[#0A0A0A]">
              SEGURIDAD
              <br />
              PERIMETRAL Y
              <br />
              <span className="text-[#F5E60F]">HERRERÍA.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#3A3A3A] text-base md:text-lg leading-relaxed">
              Catálogo completo de fabricación e instalación con foco en
              seguridad. Cada producto se ejecuta con materia prima certificada,
              cálculo estructural y cumplimiento total de normativa.
            </p>
          </div>
        </div>

        {/* Hero image strip */}
        <div className="mb-10 border-2 border-[#0A0A0A] overflow-hidden h-56 md:h-72 relative group">
          <img
            src={SERVICE_IMG_1}
            alt="Malla ciclónica industrial"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" />
          <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 text-white">
            <p className="font-mono-tag text-xs text-[#FFF44F] mb-2">FABRICACIÓN INTEGRAL</p>
            <p className="font-display text-3xl md:text-5xl">DEL DISEÑO A LA INSTALACIÓN.</p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 border-t border-l border-[#0A0A0A] bg-[#FAFAF5]">
          {SERVICES.map((service, i) => (
            <ServiceCard
              key={service.title}
              service={service}
              index={i}
              onSelect={scrollToContactWithPrefill}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
